// 飞兔请求

import request from '@public/http/ftRequest'
import Vue from 'vue'
import { RESPONSE_CODE } from '@public/http/config'

const msgVue = new Vue()

const then = res => {
  const { code } = res
  if (code === RESPONSE_CODE.SUCCESS) {
    return res
  } else {
    msgVue.$message.error(res.msg)
    return Promise.reject(res)
  }
}

const fetch = function (url, data, option) {
  option = Object.assign(option || {})
  const arg = [url, data, option]
  if (option && option.handle) { return request.apply(null, arg) }
  return request.apply(null, arg).then(then)
}
fetch.get = function (url, option) {
  option = Object.assign(option || {})
  const arg = [url, option]
  if (option && option.handle) { return request.get.apply(null, arg) }
  return request.get.apply(null, arg).then(then)
}
fetch.post = function (url, data, option) {
  option = Object.assign(option || {})
  const arg = [url, data, option]
  if (option && option.handle) { return request.post.apply(null, arg) }
  return request.post.apply(null, arg).then(then)
}
fetch.upload = function (url, data, option) {
  option = Object.assign(option || {}, { headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' }})
  const formData = new FormData()
  for (const key in data) {
    formData.append(key, data[key])
  }
  const arg = [url, formData, option]
  if (option && option.handle) { return request.post.apply(null, arg) }
  return request.post.apply(null, arg).then(then)
}
fetch.download = async function (url, data, option) {
  option = Object.assign(option || {}, { responseType: 'arraybuffer', timeout: 60 * 1000, handle: true })
  const arg = [url, data, option]
  if (option && option.handle) { return request.post.apply(null, arg) }
  return request.post.apply(null, arg).then(then)
}

export default fetch
